import React, { memo } from 'react'

import { TourNearByNav } from '../../../../components';
import { withAppStoreValue, ITour, ITopToursCategory } from '../../../../store';

interface INearByNavExtraProps {
    tour: ITour
}

interface INearByNavAppStoreProps {
    selectedTopCategory: ITopToursCategory
}

const NearByNavCore = memo(({ tour, selectedTopCategory } : INearByNavExtraProps & INearByNavAppStoreProps) => {
    return (
        <TourNearByNav
            tour={tour}
            selectedTopCategory={selectedTopCategory}
            backText="Back"
        />
    )
})

export const NearByNav = withAppStoreValue<INearByNavAppStoreProps, INearByNavExtraProps>(NearByNavCore, ['categories.selectedTopCategory'])